//创建vue实例组件通信
import Vue from 'vue';
export default new Vue();



// WEBPACK FOOTER //
// ./src/assets/js/eventBus.js